import { render, staticRenderFns } from "./HorizontalFooter.vue?vue&type=template&id=16b5f1e6&"
import script from "./HorizontalFooter.vue?vue&type=script&lang=js&"
export * from "./HorizontalFooter.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VCol,VContainer,VFooter})
